export default __webpack_public_path__ + "static/media/showroom38.d4efe2dc.jpg";